<script>

  export let color;

</script>

<svg width="60" height="60" viewBox="0 0 83 83" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g>
    <circle cx="41.5" cy="37.5" r="37.5" fill="{color}"/>
  </g>
  <path d="M63.3207 24.199C54.0807 34.9745 40.5002 32.5 40.5002 32.5V24.926C40.5022 24.3713 40.1897 23.8616 39.6936 23.6135C39.1975 23.3655 38.6037 23.4202 38.1604 23.7561L18.9649 38.1351C18.377 38.5765 18.0312 39.2679 18.0312 40.0023C18.0312 40.7367 18.377 41.4301 18.9649 41.8695L38.1348 56.2445C38.5782 56.5961 39.1818 56.6586 39.6876 56.4086C40.1935 56.1586 40.5099 55.639 40.5001 55.0746V47.5006C61.3906 47.5006 65.3556 33.0006 66.0001 25.2446C66.0567 24.5825 65.67 23.9633 65.0509 23.7231C64.4318 23.4809 63.7267 23.6762 63.3204 24.1996L63.3207 24.199Z" fill="white" style="fill: white;"/>
</svg>
